import { render } from "./DeviceLogin.vue?vue&type=template&id=a37fbaaa"
import script from "./DeviceLogin.vue?vue&type=script&lang=js"
export * from "./DeviceLogin.vue?vue&type=script&lang=js"

import "./DeviceLogin.vue?vue&type=style&index=0&id=a37fbaaa&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__